// models/playerModel.js

class Player {
 constructor({
   id,
   nom,
   anneeNaissance,
   dateNaissance,
   taille,
   poids,
   poste,
   type,
   groupes = [],
   // Correspondances filtres front :
   nacionalidad,
   segundaNacionalidad,
   origenEtnico,
   seleccionNacional,
   manoDominante,
   rolOfensivo,
   rolDefensivo,
   shootingRange,
   categoria,
   currentVBCRating,
   proyeccionVBCRating,
   flagBehaviour,
   injuryProne,
   digitalBehaviour,
   comparacionPro,
   equipoActual,
   ligaSecundaria,
   // Draft/Expériences :
   equipoPreDraft,
   anioDraft,
   posicionDraft,
   experienciaAcb,
   nbaExperience,
   experienciaEuropa,
   experienciaFuera,
   experienciaNcaa,
   pit,
   eurocamp,
   slvegas,
   // Contrat / Agence :
   agencia,
   rangoPrecios,
   contrato,
   buyout,
   url,
   jeJiType,
   jeJiAttributes,
   in_big_board,
   in_informe,
   in_intel,
   in_follow_list,
   in_fiche_technique,
   in_video,
   in_injury,
   in_tanteo,
   has_medidas,
   has_documents,
   // Champs non filtrés :
   estatus,
   pasaporte,
   grado,
   nivel,
   proyeccion,
   team,
   league_2,
   is_free_agent,

   // --- AJOUT : tableau de toutes les mesures (table "medidas") ---
   medidas,

   // --- Stats (JSON) ---
   stats,
   
   // --- Forme indicator ---
   forme_indicator,
   
   // --- Nb informe et nb scout ---
   nb_informe,
   nb_scout,
   
   // --- Scout verdicts ---
   scout_verdicts,
   scout_verdicts_count,
   
   // --- NOUVEAU : Détails des compétitions ---
   competitions_detail
 }) {
   this.id = id;
   this.nom = nom;
   this.anneeNaissance = anneeNaissance;
   this.dateNaissance = dateNaissance;
   this.taille = taille;
   this.poids = poids; // Vient de la table players
   this.poste = poste;
   this.type = type;
   this.groupes = groupes;

   // Correspondances exactes avec les "Filters" :
   this.nacionalidad = nacionalidad;
   this.segundaNacionalidad = segundaNacionalidad;
   this.origenEtnico = origenEtnico;
   this.seleccionNacional = seleccionNacional;
   this.manoDominante = manoDominante;
   this.rolOfensivo = rolOfensivo;
   this.rolDefensivo = rolDefensivo;
   this.shootingRange = shootingRange;
   this.categoria = categoria;
   this.currentVBCRating = currentVBCRating;
   this.proyeccionVBCRating = proyeccionVBCRating;
   this.flagBehaviour = flagBehaviour;
   this.injuryProne = injuryProne;
   this.digitalBehaviour = digitalBehaviour;
   this.comparacionPro = comparacionPro;
   this.equipoActual = equipoActual;
   this.ligaSecundaria = ligaSecundaria;

   // Expérience / Draft :
   this.equipoPreDraft = equipoPreDraft;
   this.anioDraft = anioDraft;
   this.posicionDraft = posicionDraft;
   this.experienciaAcb = experienciaAcb;
   this.nbaExperience = nbaExperience;
   this.experienciaEuropa = experienciaEuropa;
   this.experienciaFuera = experienciaFuera;
   this.experienciaNcaa = experienciaNcaa;
   this.pit = pit;
   this.eurocamp = eurocamp;
   this.slvegas = slvegas;

   // Contrat / Agence :
   this.agencia = agencia;
   this.rangoPrecios = rangoPrecios;
   this.contrato = contrato;
   this.buyout = buyout;

   // Autres :
   this.url = url;
   this.jeJiType = jeJiType;
   this.jeJiAttributes = jeJiAttributes;

   // Indicateurs divers :
   this.in_big_board = in_big_board;
   this.in_informe = in_informe;
   this.in_intel = in_intel;
   this.in_follow_list = in_follow_list;
   this.in_fiche_technique = in_fiche_technique;
   this.in_video = in_video;
   this.in_injury = in_injury;
   this.in_tanteo = in_tanteo;
   this.has_medidas = has_medidas;
   this.has_documents = has_documents;

   // Champs non filtrés (restants) :
   this.estatus = estatus;
   this.pasaporte = pasaporte;
   this.grado = grado;
   this.nivel = nivel;
   this.proyeccion = proyeccion;
   this.team = team;
   this.league_2 = league_2;
   this.is_free_agent = is_free_agent;

   // --- Tableau de toutes les mesures (table "medidas") ---
   this.medidas = medidas;

   // --- Stats (JSON) ---
   this.stats = stats;
   
   // --- Forme indicator ---
   this.forme_indicator = forme_indicator;
   
   // --- Nb informe et nb scout ---
   this.nb_informe = nb_informe;
   this.nb_scout = nb_scout;
   
   // --- Scout verdicts ---
   this.scout_verdicts = scout_verdicts;
   this.scout_verdicts_count = scout_verdicts_count;
   
   // --- NOUVEAU : Détails des compétitions ---
   this.competitions_detail = competitions_detail;
 }

 static fromJSON(json) {
   return new Player({
     id: json.id,
     nom: json.nom,
     anneeNaissance: json.annee_naissance,
     dateNaissance: json.date_naissance,
     taille: json.taille,
     poids: json.poids, // champ de la table players
     poste: json.poste,
     type: json.type,
     groupes: json.groupes || [],

     // On mappe ici les champs tels qu'ils arrivent du back/DB :
     nacionalidad: json.nationalite,
     segundaNacionalidad: json.nationalite_2,
     origenEtnico: json.origen_genetico,
     seleccionNacional: json.selection_national,
     manoDominante: json.mano,
     rolOfensivo: json.offensive_role,
     rolDefensivo: json.defensive_role,
     shootingRange: json.shooting_range,
     categoria: json.categoria,
     currentVBCRating: json.level,
     proyeccionVBCRating: json.proyeccion,
     flagBehaviour: json.flag_behaviour,
     injuryProne: json.injury,
     digitalBehaviour: json.digital_behaviour,
     comparacionPro: json.pro_comparaison,
     equipoActual: json.team,
     ligaSecundaria: json.league_2,

     // Expérience / Draft :
     equipoPreDraft: json.pre_draft_team,
     anioDraft: json.draft_year,
     posicionDraft: json.draft_pick,
     experienciaAcb: json.acb_experience,
     nbaExperience: json.nba_experience,
     experienciaEuropa: json.experienca_europa,
     experienciaFuera: json.experienca_fuera,
     experienciaNcaa: json.experienca_ncaa,
     pit: json.pit,
     eurocamp: json.eurocamp,
     slvegas: json.slvegas,

     // Contrat / Agence :
     agencia: json.agency,
     rangoPrecios: json.price_range,
     contrato: json.contract,
     buyout: json.buyout,

     // Autres / Divers :
     url: json.url,
     jeJiType: json.je_ji,
     jeJiAttributes: json.selection_je_ji,

     // Indicateurs  : 
     in_big_board: json.is_in_big_board,
     in_informe: json.is_in_informe,
     in_intel: json.is_in_intel,
     in_follow_list: json.is_in_follow_list,
     in_fiche_technique: json.is_in_fiche_technique,
     in_video: json.is_in_video,
     in_injury: json.is_in_injury,
     in_tanteo: json.is_in_tanteo,
     has_medidas: json.has_medidas,
     has_documents: json.has_documents,

     // Non filtrés (restants) : 
     estatus: json.statut,
     pasaporte: json.passport,
     grado: json.grade,
     nivel: json.level,
     proyeccion: json.proyeccion,
     team: json.team,
     league_2: json.league_2,
     is_free_agent: json.is_free_agent,

     // --- Tableau de toutes les mesures (table "medidas") ---
     medidas: json.medidas,

     // --- Stats (JSON) --- 
     stats: json.stats,
     
     // --- Forme indicator ---
     forme_indicator: json.forme_indicator,
     
     // --- Nb informe et nb scout ---
     nb_informe: json.nb_informe,
     nb_scout: json.nb_scout,
     
     // --- Scout verdicts ---
     scout_verdicts: json.scout_verdicts,
     scout_verdicts_count: json.scout_verdicts_count,
     
     // --- NOUVEAU : Détails des compétitions ---
     competitions_detail: json.competitions_detail
   });
 }
}

export default Player;